export default {
  state: {
    banner: null,
  },
  getters: {
    topBanner: s => s.banner,
  },
  mutations: {
    updateTopBanner(s, banner) {
      s.banner = banner
    },
  },
  actions: {
    async fetchTopBanner(ctx, url) {
      return this.$axios({
        method: 'GET',
        url: `/api/content/page-banners/?url=${url}`,
      })
        .then((response) => {
          const status = response.data.status;
          if (status >= 400) {
            return false
          }
          ctx.commit('updateTopBanner', response.data)
          return true
        })
        .catch((error) => {
          ctx.commit('updateTopBanner', null)
          return false
        });
    },
  },
}
